import React from "react";

/** Shopping-cart glyph used as the Store control. */
export default function StoreIcon({ className = "storeIcon", title = "Store" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            aria-hidden={title ? undefined : true}
            role={title ? "img" : "presentation"}
            focusable="false"
        >
            {title ? <title>{title}</title> : null}
            <path
                fill="currentColor"
                d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM7.2 14h9.8c.75 0 1.41-.41 1.75-1.03l3.24-5.88A1 1 0 0 0 21.1 6H6.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 17.37 5.48 19 7 19h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L7.2 14zM6.16 8h13.02l-2.76 5H8.53L6.16 8z"
            />
        </svg>
    );
}
